export interface Scripts {
	name: string;
	src: string;
}
export const ProdScript: Scripts[] = [{ name: 'hs-script-loader', src: 'https://js.hs-scripts.com/46950108.js' }];

export const LazyLoadScript: Scripts[] = [
	{ name: 'pdfmake-pdfmake', src: './pdfmake-pdfmake.js' },
	{ name: 'pdfmake-vfs_fonts', src: './pdfmake-vfs_fonts.js' },
	{ name: 'exceljs', src: './exceljs.js' },
];
